import React, { useEffect, useState } from 'react';

import clsx from 'clsx';
import makeStyles from '@material-ui/core/styles/makeStyles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Link from '@material-ui/core/Link';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import Divider from '@material-ui/core/Divider';
import SvgIcon from '@material-ui/core/SvgIcon';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';

import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import DevicesIcon from '@material-ui/icons/Devices';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import PersonIcon from '@material-ui/icons/Person';
import AccountBalanceOutlinedIcon from '@material-ui/icons/AccountBalanceOutlined';
import EmailOutlinedIcon from '@material-ui/icons/EmailOutlined';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import DashboardOutlinedIcon from '@material-ui/icons/DashboardOutlined';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import StorageIcon from '@material-ui/icons/Storage';
import CodeIcon from '@material-ui/icons/Code';
import EqualizerOutlinedIcon from '@material-ui/icons/EqualizerOutlined';
import LocalShippingOutlinedIcon from '@material-ui/icons/LocalShippingOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import DeveloperBoardIcon from '@material-ui/icons/DeveloperBoard';
import PagesIcon from '@material-ui/icons/Pages';
import ThumbUpOutlinedIcon from '@material-ui/icons/ThumbUpOutlined';
import AssignmentOutlinedIcon from '@material-ui/icons/AssignmentOutlined';
import DescriptionOutlinedIcon from "@material-ui/icons/DescriptionOutlined";
import SubjectOutlinedIcon from '@material-ui/icons/SubjectOutlined';

import DevicesOnline from './DevicesOnline';
import AccountWidget from './AccountWidget';
import Logo from 'website_logo_MSTR.png';
import { ReactComponent as DeviceI } from './device.svg';
import { ReactComponent as WebhookI } from './Webhook.svg';
import { ReactComponent as GatewayI } from './Gateway.svg';
import zIndex from '@material-ui/core/styles/zIndex';
import { DvrOutlined } from '@material-ui/icons';

const GatewayIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <GatewayI />
    </SvgIcon>
  )
}

const DeviceIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <DeviceI />
    </SvgIcon>
  )
}

const WebhookIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <WebhookI />
    </SvgIcon>
  )
}

const drawerWidth = 220;

const useStyles = makeStyles((theme) => ({

  hide: {
    display: 'none',
  },
  wrapperAppBar: {
    height: theme.spacing(11),
    zIndex: theme.zIndex.modal + 10,
  },
  appBar: {
    zIndex: 'inherit',
    backgroundColor: '#FFFFFF',
    color: '#000000',
    height: theme.spacing(8),
    justifyContent: 'center',
    overflowX: 'hidden',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarDevicesOnline: {
    zIndex: 'inherit',
    height: theme.spacing(3),
    backgroundColor: '#404040',
    padding: '5px',
    textAlign: 'right',
    fontSize: '9pt',
    color: '#FFF',
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  mainAppBar: {
    position: 'relative',
  },
  logo: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(3),
    '&:hover': {
      cursor: 'pointer',
    },
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(8),
    },
  },
  navMenu: {
    display: `none`,
    justifyContent: `space-between`,
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    }
  },
  navLink: {
    display: 'none',
    color: '#404040',
    fontWeight: '400',
    [theme.breakpoints.up('md')]: {
      display: 'unset'
    },
    '&:hover': {
      cursor: 'pointer',
    },
  },
  navLinkActive: {
    color: '#FF8C23',
    textDecoration: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
  },
  drawerOpen: {
    display: 'unset !important',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: theme.spacing(6) + 1,
    [theme.breakpoints.up('md')]: {
      width: theme.spacing(7) + 1,
    },
  },
  toolbar: {
    height: theme.spacing(11),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
  },
  sideNav: {
    backgroundColor: '#E0E0E0',
    display: 'none',
    zIndex: 1305,
    [theme.breakpoints.up('md')]: {
      paddingTop: theme.spacing(13),
      display: 'unset',
    },
  },
  menuButton: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  mobileNav: {
    [theme.breakpoints.up('md')]: {
      display: 'none',
    }
  },

}))


const sideLinks = {
  web: [
    { icon: <HomeOutlinedIcon />, text: "HOME", link: "/" },
    { icon: <InfoOutlinedIcon />, text: "ABOUT", link: "/about" },
    { icon: <DeviceIcon />, text: "PEBL", link: "/pebl" },
    { icon: <GatewayIcon />, text: "VYNE", link: "/vyne" },
    { icon: <EmailOutlinedIcon />, text: "CONTACT", link: "/contact" },
    { icon: <PagesIcon />, text: "PRICING", link: '/pricing' },
    { icon: <DeveloperBoardIcon />, text: "SIMULATOR", link: '/simulator' },
    { icon: <ThumbUpOutlinedIcon />, text: "THANK YOU", link: '/thankyou' }
  ],
  account: [
    { icon: <AccountBalanceOutlinedIcon />, text: "ORGANISATION", link: "/organisation" },
    { icon: <PersonIcon />, text: "USER", link: "/user" },
    { icon: <CreditCardIcon />, text: "BILLING", link: "/billing" },
  ],
  store: [
    { icon: <DeviceIcon />, text: "PEBL", link: '/pebl' },
    { icon: <GatewayIcon />, text: "VYNE", link: '/vyne' },
    { icon: <DvrOutlined />, text: "DIGITAL", link: '/digital' },
    { icon: <ShoppingBasketIcon />, text: "BASKET", link: "/basket" },
    { icon: <LocalShippingOutlinedIcon />, text: "ORDERS", link: '/orders' },
  ],
  portal: [
    { icon: <DashboardOutlinedIcon />, text: "DASHBOARD", link: "/" },
    { icon: <DevicesIcon />, text: "DEVICES", link: "/devices" },
    { icon: <WebhookIcon />, text: "WEBHOOKS", link: "/webhooks" },
    { icon: <SettingsOutlinedIcon />, text: "SETTINGS", link: "/settings" },
    { icon: <AssignmentOutlinedIcon />, text: "REPORTS", link: "/reports" }
  ],
  developer: [
    { icon: <DescriptionOutlinedIcon />, text: "DOCUMENTATION", link: "/documentation" },
    { icon: <SubjectOutlinedIcon />, text: "REFERENCE", link:  "/reference" },
    { icon: <CodeIcon />, text: "SDK", link: "/sdk" },
  ],
}

const FingotiNav = (props) => {

  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [devicesOnline, setDevicesOnline] = useState(0);
  const { onSideNavClick, onBackClick, currentApp, useProfileState, handleSwitchOrganisation, handleLogout, config } = props;

  const links = [
    { text: "Account", link: config.accountUrl },
    { text: "Portal", link: config.portalUrl },
    { text: "Documentation", link: config.developerUrl },
    { text: "Store", link: config.storeUrl },
  ]

  useEffect(() => {
    getDevicesOnline();
  }, []);

  const getDevicesOnline = () => {
    fetch(`${config.apiUrl}/device/online`)
      .then(response => {
        response.text().then(text => {
          const data = text && JSON.parse(text);
          if (!response.ok) {
            setDevicesOnline(0);
          } else {
            setDevicesOnline(data.devicesOnline);
          }
        })
      })
      .catch(() => {
        setDevicesOnline(0);
      })
  }

  const handleMainNav = (link) => {
    window.location.assign(link);
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleMobileDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleMobileDrawerClick = (link) => {
    handleMobileDrawerToggle();
    onSideNavClick(link);
  }

  return (
    <React.Fragment>
      <AppBar
        elevation={4}
        position="sticky"
        className={classes.wrapperAppBar}
      >
        <AppBar position="sticky" className={classes.appBarDevicesOnline}>
          <DevicesOnline devicesOnline={devicesOnline} />
        </AppBar>
        <AppBar
          elevation={4}
          position="sticky"
          className={clsx(classes.appBar, classes.mainAppBar)}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="Open drawer"
              onClick={handleMobileDrawerToggle}
              className={classes.menuButton}
            >
              <MenuIcon />
            </IconButton>
            <img
              src={Logo}
              height="32"
              width="160"
              className={classes.logo}
              onClick={() => window.location.assign(config.webUrl)}
            />
            <List
              component="nav"
              className={classes.navMenu}
            >
              {
                links.map((link, i) => {
                  return (
                    <ListItem key={i}>
                      <Link
                        href={link.link}
                        underline="none"
                        className={clsx(classes.navLink, {
                          [classes.navLinkActive]: currentApp === link.text.toLocaleLowerCase()
                        })}>
                        {link.text}
                      </Link>
                    </ListItem>
                  )
                })
              }
            </List>
              <AccountWidget
                useProfileState={useProfileState}
                handleSwitchOrganisation={handleSwitchOrganisation}
                handleLogout={handleLogout}
                config={config}
              />
          </Toolbar>
        </AppBar>
      </AppBar>
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, {
          [classes.drawerOpen]: open,
          [classes.drawerClose]: !open,
        })}
        classes={{
          paper: clsx(classes.sideNav, {
            [classes.drawerOpen]: open,
            [classes.drawerClose]: !open,
          }),
        }}
      >
        <List>
          {sideLinks[currentApp].map((link, i) => (
            <ListItem
              onMouseEnter={handleDrawerOpen}
              onMouseLeave={handleDrawerClose}
              onClick={() => onSideNavClick(link.link)}
              button
              key={i}
            >
              <ListItemIcon>{link.icon}</ListItemIcon>
              <ListItemText primary={link.text} />
            </ListItem>
          ))}
        </List>
      </Drawer>
      <Drawer
        variant="permanent"
        anchor="right"
        className={classes.drawerClose}
        classes={{ paper: clsx(classes.sideNav, classes.drawerClose) }}
      />
      <Drawer
        variant="permanent"
        className={clsx(classes.drawer, classes.mobileNav, {
          [classes.drawerOpen]: mobileOpen,
          [classes.drawerClose]: !mobileOpen,
        })}
        classes={{
          paper: clsx(classes.sideNav, {
            [classes.drawerOpen]: mobileOpen,
            [classes.drawerClose]: !mobileOpen,
          }),
        }}
      >
        <div className={classes.toolbar}>
          <IconButton onClick={handleDrawerClose}>
            <ChevronLeftIcon />
          </IconButton>
        </div>
        <Divider />
        <List>
          <ListItem
            onMouseEnter={handleDrawerOpen}
            onMouseLeave={handleDrawerClose}
            onClick={() => onBackClick()}
            button
          >
            <ListItemIcon>
              <ArrowBackIcon />
            </ListItemIcon>
            <ListItemText primary="Back" />
          </ListItem>
          {sideLinks[currentApp].map((link, i) => (
            <ListItem
              onClick={() => handleMobileDrawerClick(link.link)}
              button
              key={i}
            >
              <ListItemIcon>{link.icon}</ListItemIcon>
              <ListItemText primary={link.text} />
            </ListItem>
          ))}
          <Divider />
          {
            links.map((link, i) => {
              return (
                <ListItem key={i} button onClick={() => window.location.assign(link.link)}>
                  <ListItemText primary={link.text} />
                </ListItem>
              )
            })
          }
        </List>
      </Drawer>
    </React.Fragment >
  )
}

export default FingotiNav;
